import CancelIcon from "@mui/icons-material/Cancel";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { INK } from "@/theme/tokens";

type Props = {
	nurseId: number;
	onDeny: (nurseId: number) => void;
	iconFontSize?: number;
};

export const DenyNurseButton = ({ nurseId, onDeny, iconFontSize = 20 }: Props) => {
	const { t } = useTranslation();
	return (
		<Tooltip title={t("deny")} arrow>
			<IconButton
				data-testid={`deny-nurse-${nurseId}`}
				size="small"
				onClick={(e) => {
					e.stopPropagation();
					onDeny(nurseId);
				}}
			>
				<CancelIcon sx={{ fontSize: iconFontSize, color: INK.SECONDARY }} />
			</IconButton>
		</Tooltip>
	);
};

type RestoreProps = {
	nurseId: number;
	onRestore: (nurseId: number) => void;
	iconFontSize?: number;
};

export const RestoreNurseButton = ({ nurseId, onRestore, iconFontSize = 20 }: RestoreProps) => {
	const { t } = useTranslation();
	return (
		<Tooltip title={t("un.deny")} arrow>
			<IconButton
				data-testid={`restore-nurse-${nurseId}`}
				size="small"
				onClick={(e) => {
					e.stopPropagation();
					onRestore(nurseId);
				}}
			>
				<RestoreFromTrashIcon sx={{ fontSize: iconFontSize, color: INK.SECONDARY }} />
			</IconButton>
		</Tooltip>
	);
};
